<template>
<div>
    <!-- OLD DIV VERSION    <div class="col-md-10 col-sm-9 col-md-offset-2 col-sm-offset-3 content container-fluid">-->
    <div class="col-lg-12 col-md-10 col-sm-9 content container-fluid">
        <div class="wrapper">
            <div class="container-wrapper">
                <div id="alerts-container">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-lg-6">
                <h3 class="m-0"><a class="tex-cdi-primary" href="#">Ofertas</a></h3>
                <p>{{ offer.description }}</p>
            </div>
            <div class="col-xs-12 col-lg-6 text-right">
                <button class="btn btn-danger m-l-5 m-r-5" @click="deleteOffer(this.offerId)"><i class="md  md-delete sm-ico b-r b-white p-r-20 m-r-20"></i> ELIMINAR</button>
                <button class="btn btn-primary m-l-5 m-r-5" @click="storeOffer(this.offerId)"><i class="md  md-archive sm-ico b-r b-white p-r-20 m-r-20"></i> ARCHIVAR</button>
                <button class="btn btn-primary m-l-5 m-r-5" @click="unstoreOffer(this.offerId)"><i class="md  md-archive sm-ico b-r b-white p-r-20 m-r-20"></i> DESARCHIVAR</button>
                <button class="btn btn-success m-l-5" @click="openEditModal(this.offerId)"><i class="md md-mode-edit sm-ico b-r b-white p-r-20 m-r-20"></i> EDITAR</button>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 m-t-20">
                <div class="col-xs-12 b-t b-dashed b-transparent">
                    <div class="col-xs-12 col-lg-4 m-t-20">
                        <h4 class="tex-cdi-primary">TOTAL VENDIDO</h4>
                        <h2 class="tex-cdi-primary m-0" v-if="total_sold">RD$ {{ total_sold }}</h2>
                        <h2 class="tex-cdi-primary m-0" v-else="total_sold">RD$ 0.00</h2>
                    </div>
                    <div class="col-xs-12 col-lg-4  b-l b-dashed b-transparent m-t-20">
                        <h4 class="tex-cdi-primary">CUENTAS POR COBRAR</h4>
                        <h2 class="tex-cdi-primary m-0">RD${{provider.accounts_to_charge}}</h2>
                        <p class="tex-cdi-primary">({{ getDate }})</p>
                    </div>
                    <div class="col-xs-12 col-lg-4 b-l b-dashed b-transparent m-t-20">
                        <h4 class="tex-cdi-primary">CUENTAS POR PAGAR</h4>
                        <h2 class="tex-cdi-primary m-0">RD${{provider.accounts_to_pay}}</h2>
                        <p class="tex-cdi-primary">({{ getDate }})</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row m-t-20">
            <div class="col-xs-12 p-b-10 b-b b-grey">
                <ul class="nav nav-tabs offer-tabs">
                    <li class="active b-r b-grey"><a data-toggle="tab" href="#offer-info">INFORMACIÓN DE LA OFERTA</a></li>
                    <li><a data-toggle="tab" href="#clients">CLIENTES</a> <label class="bg-success clients-cant">{{offer.total_clients}}</label></li>
                </ul>
            </div>
            <div class="col-xs-12 m-t-20 tab-content">
                <!--offer information-->
                <div class="tab-pane  active" id="offer-info">
                    <div class="col-xs-12 col-lg-6">
                        <div class="panel details-panel panel-default">
                            <div class="padding-20">
                                <p>ID: <span class="text-bold pull-right">{{ offer.id }}</span></p>
                                <p>Proveedor: <span class="text-bold pull-right">{{ offer.provider }}</span></p>
                                <p>Representante: <span class="text-bold pull-right">{{ provider.representative ? provider.representative.name : '' }}</span></p>
                                <p>Teléfono del representante: <span class="text-bold pull-right">{{ provider.representative ? provider.representative.phone : ''}}</span></p>
                                <p>Correo del representante: <span class="text-bold pull-right">{{ provider.representative ? provider.representative.email : '' }}</span></p>
                                <p>Vigencia de la oferta: <span class="text-bold pull-right">{{ returnValidityInfo }}</span></p>
                                <p>Fecha de creación: <span class="text-bold pull-right">{{ offer.created_at }}</span></p>
                                <p>Fecha de inicio: <span class="text-bold pull-right">{{ offer.start_date }}</span></p>
                                <p>Fecha de expiración: <span class="text-bold pull-right">{{ offer.due_date }}</span></p>
                                <p>Tipo de oferta: <span class="text-bold pull-right">{{ offer.type ? offer.type.name : '' }}</span></p>
                                <p v-if="days">Días: <span class="text-bold pull-right">{{ offer.days }}</span></p>
                                <p v-else>Cuotas: <span class="text-bold pull-right">{{ offer.fee }}</span></p>
                                <p>Porcentaje de comisión: <span class="text-bold pull-right">{{ offer.comission_percent }}%</span></p>
                                <p>Porcentaje de descuento: <span class="text-bold pull-right">{{ offer.discount_percent }}%</span></p>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-lg-6 ">
                        <div class="panel details-panel panel-default">
                            <div class="padding-20 clearfix">
                                <div class="fav-img pull-right">
                                    <i class="md md-star star-ico pull-right"></i>
                                </div>
                                <div class="img-holder col-xs-12 b-a b-grey b-rad-lg center" :style="offerImage"></div>
                            </div>
                            <div class="p-l-20 p-r-20 p-b-20 clearfix">
                                <div class="offer-title m-t-20">
                                    <h4>Título</h4>
                                    <p>{{ offer.title }}</p>
                                </div>

                                <div class="offer-desc">
                                    <h4>Descripción</h4>
                                    <p>{{ offer.description }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- clients table info-->
                <div class="tab-pane" id="clients">
                    <div class="col-xs-12 m-t-20 m-b-20 text-right">
                        <!-- <button class="btn btn-primary m-l-5 m-r-5"><i class="md  md-file-download sm-ico b-r b-white p-r-20 m-r-20"></i> DESCARGAR</button> -->
                    </div>
                    <div class="clearfix"></div>
                    <template v-for="company in companies">
                        <div class="col-xs-12 col-lg-3">
                            <a v-link="{ name: 'purchased-offers',params: { companyId: company.company_id } }" >
                                <div class="account-item">
                                    <div class="panel panel-default">
                                        <div class="panel-heading">
                                            <h3 class="panel-title">{{ company.company_name }}</h3>
                                        </div>
                                        <div class="panel-body">
                                            <h3 class="text-center">{{ company.total }}</h3>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </template>
                </div>
                <!-- /.clients table info-->
            </div>
        </div>
        <!-- /.Edit offer info-->
        <div class="modal fade  bs-example-modal-lg" id="edit-offer">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="col-xs-12">
                            <h2 class="pull-left">Editar oferta</h2>
                            <i class="md md-star-outline star-ico pull-right"></i>
                        </div>
                        <div class="col-xs-12 col-lg-6 b-r b-grey">
                            <div class="form-group">
                                <h5>Tipo de oferta</h5>
                                <select class="full-width" data-init-plugin="select2" v-model="selectedType">
                                      <option v-for="typeResult in type" :value="typeResult.id">{{ typeResult.name }}</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <h5>Segmento</h5>
                                <select class="full-width" data-init-plugin="select2" v-model="selectedServiceType">
                                      <option v-for="ServiceTypeResult in serviceType" :value="ServiceTypeResult.id">{{ ServiceTypeResult.name }}</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <h5>Proveedor</h5>
                                <div class="form-group" data-init-plugin="select2">
                                    <select class="full-width" v-model="selectedProvider">
                                        <option v-for="provider in providers" :value='provider.id'>{{ provider.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group" v-if='selectedType == 1'>
                                <div class="col-xs-12 col-lg-6 padding-0">
                                    <h5>Cuotas</h5>
                                </div>
                                <div class="col-xs-12 col-lg-6 padding-0">
                                    <input type="number" class='full-width' min="0" max="6" min="0" v-model="fee" v-show='selectedType == 1'>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="form-group" v-else>
                                <div class="col-xs-12 col-lg-6 padding-0">
                                    <h5>Días</h5>
                                </div>
                                <div class="col-xs-12 col-lg-6 padding-0">
                                    <input type="number" class='full-width' min="0" max="6" v-model="days" v-show='selectedType == 2'>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <!--                             <div class="form-group">
                                <div class="col-xs-12 col-lg-6 padding-0" v-if='selectedType == 1'>
                                    <h5>Cuota</h5>
                                    <div class="col-xs-12 col-lg-6 padding-0">
                                        <input type="text" class='form-control' name="editFee" v-model="editFee" v-show='selectedType == 1' placeholder="editFee">
                                    </div>
                                </div>
                                <div class="col-xs-12 col-lg-6 padding-0" v-else>
                                    <h5>Dias</h5>
                                    <div class="col-xs-12 col-lg-6 padding-0">
                                        <input type="text" class='form-control' name="editDays" v-model="editDays" v-show='selectedType == 2'>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                            </div> -->
                            <div class="form-group">
                                <div class="col-xs-12 col-lg-6 padding-0">
                                    <h5>Porcentaje de comisión</h5>
                                </div>
                                <div class="col-xs-12 col-lg-6 padding-0">
                                    <input type="number" class='full-width' min="0" v-model="editComissionPercent">
                                </div>
                                <div class="clearfix"></div>
                            </div>

                            <div class="form-group">
                                <div class="col-xs-12 col-lg-6 padding-0">
                                    <h5>Porcentaje de descuento</h5>
                                </div>
                                <div class="col-xs-12 col-lg-6 padding-0">
                                    <input type="number" class='full-width' min="0" name="" v-model="editDiscountPercent">
                                </div>
                                <div class="clearfix"></div>
                            </div>

                            <div class="col-xs-12 padding-0">
                                <h5 class="bold">Vigencia</h5>
                                <div class="radio radio-default b-b b-grey p-b-10">
                                    <div class="col-xs-12 col-lg-6 b-r b-grey text-center">
                                        <input type="radio" checked="checked" name="radio1" id="infinity" v-model='editValidity' value="0">
                                        <label for="infinity">Indefinida</label>
                                    </div>
                                    <div class="col-xs-12 col-lg-6 text-center">
                                        <input type="radio" name="radio1" id="temporal" v-model='editValidity' value="1">
                                        <label for="temporal">Temporal</label>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                                <div class="col-xs-12 col-lg-6">
                                    <label>Fecha de inicio</label>
                                    <div id="first-date" class="input-group date">
                                        <input type="text" class="form-control" placeholder="00/00/00" v-model="editStartDate" id="first-date">
                                        <span class="input-group-addon bg-white"><i class="fa fa-calendar"></i>
                                        </span>
                                    </div>

                                </div>
                                <div class="col-xs-12 col-lg-6">
                                    <label class="text-disable">Fecha de fin</label>
                                    <div class="input-group" v-show="editValidity == '0'">
                                        <input type="text" class="form-control" placeholder="//" disabled>
                                        <span class="input-group-addon"><i class="fa fa-calendar"></i>
                                        </span>
                                    </div>
                                    <div class="input-group" v-show="editValidity == '1'">
                                        <input type="text" class="form-control" placeholder="//" v-model="editDueDate" id="last-date">
                                        <span class="input-group-addon"><i class="fa fa-calendar"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <hr>
                            <div class="checkbox check-default">
                                <input type="checkbox" checked="checked" value="1" id="checkbox1" v-model="editInternOffer">
                                <label for="checkbox1">Oferta interna</label>
                            </div>
                        </div>
                        <div class="col-xs-12 col-lg-6">
                            <div class="img-holder col-xs-12 b-a b-grey b-dashed center">
                                <label class="text-center dropzone">
                                    <div class="drop-hov">
                                        <input type="file" @change="sync($event, 'imagen')" required/>
                                        <h4 class="text-success m-0" v-if="!imageSrc">
                                            <i class="md md-add-circle xl-ico"></i>
                                            <br>
                                            AGREGAR IMAGEN
                                        </h4>
                                        <div v-else="imageSrc">
                                            <img :src="imageSrc">
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <div class="input-group col-xs-12">
                                <h5>Título</h5>
                                <input type="text" class="form-control" v-model="editTitle">
                            </div>
                            <div class="input-group col-xs-12">
                                <h5>Descripción</h5>
                                <textarea type="text" class="form-control" v-model="editDescription"></textarea>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <div class="modal-footer">
                        <div class="row">
                            <div class="col-xs-12 text-center">
                                <a data-dismiss="modal" class="btn btn-bgrey">CANCELAR</a>
                                <a class="btn btn-success" @click="editOffer(this.offerId)">EDITAR</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            api: API,
            offer: [],
            selectedType: '',
            selectedServiceType: '',
            selectedProvider: '',
            editFee: '',
            editDays: '',
            editComissionPercent: '',
            editDiscountPercent: '',
            editValidity: '',
            editStartDate: '',
            editDueDate: '',
            editInternOffer: '',
            editTitle: '',
            editDescription: '',
            representativeId: '',
            provider: [],
            providers: [],
            companies: [],
            typeId: '',
            providerId: '',
            imagen: null,
            fee: '',
            days: '',
            total_sold: '',
            comission_percent: '',
            type: [],
            serviceType: [],
            offerId: this.$route.params.id,
            offerImage: '',
            imageSrc: '',
        }
    },
    created() {
        this.getOffer();
        this.getAllProviders();
        this.getOfferType();
        this.getOfferServiceType();
    },
    methods: {

        getOffer: function() {
            this.$http.get(apiUrl + '/offers/' + this.offerId).then(response => {
                this.offer = response.data;
                this.representativeId = response.data.provider_id;
                this.fee = response.data.fee;
                this.days = response.data.days;
                this.total_sold = response.data.total_sold;
                this.comission_percent = response.data.comission_percent;
                this.typeId = response.data.type.id;
                this.selectedType = response.data.type.id;
                this.selectedServiceType = response.data.service_type_id;
                this.editFee = response.data.fee;
                this.editDays = response.data.days;
                this.editTitle = response.data.title;
                this.editDescription = response.data.description;
                this.editComissionPercent = response.data.comission_percent;
                this.editDiscountPercent = response.data.discount_percent
                this.selectedProvider = response.data.provider_id;
                this.editStartDate = response.data.start_date;
                this.getProvider();
                this.getCompanies();
                this.offerImage = `background: url(${this.api}${this.offer.image}) no-repeat center; background-size: cover;`;
            });
        },

        getProvider: function() {
            this.$http.get(apiUrl + '/providers/' + this.representativeId).then(response => {
                this.provider = response.data;
                //this.selectedProvider = response.data.name;
            });
        },

        getCompanies: function() {
            this.$http.get(apiUrl + '/offers/companies/' + this.offer.id).then(response => {
                this.companies = response.data;
            });
        },

        openEditModal: function(offerId) {
            $('#edit-offer').modal('show');
            $('#first-date').datepicker();
            $('#last-date').datepicker();
        },

        editOffer: function(offerId) {
            var self = this;
            console.log(self.selectedServiceType);
            $.ajax({
                url: apiUrl + '/offers/' + offerId,
                type: 'PUT',
                data: {
                    'title': this.editTitle,
                    'description': this.editDescription,
                    'comission_percent': this.editComissionPercent,
                    'discount_percent': this.editDiscountPercent,
                    'fee': this.editFee,
                    'days': this.editDays,
                    'start_date': this.editStartDate,
                    'due_date': this.editDueDate,
                    'validity': this.editValidity,
                    'provider_id': this.selectedProvider,
                    'type_id': this.selectedType,
                    'service_type_id': self.selectedServiceType,
                    'image': this.imagen,

                },
                success: function(response) {
                    swal({
                        title: "Felicidades!",
                        text: "La oferta se edito correctamente.!",
                        type: "success",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Continuar!",
                        closeOnConfirm: false,
                    });
                    self.getOffer();
                    $('#edit-offer').modal('toggle');
                },
                error: function(request, error) {
                    alert("Ha ocurrido un error al intentar arcguvar la oferta");
                }
            });
        },

        storeOffer: function(offerId) {
            swal({
                    title: "Estás seguro?",
                    text: "Deseas archivar esta oferta?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Si",
                    cancelButtonText: "Cancelar",
                    closeOnConfirm: false,
                    closeOnCancel: false
                },
                function(isConfirm) {
                    if (isConfirm) {
                        $.ajax({
                            url: apiUrl + '/offers/' + offerId,
                            type: 'PUT',
                            data: {
                                'status_id': 2
                            },
                            success: function(response) {
                                swal({
                                        title: "Felicidades!",
                                        text: "La oferta se archivo correctamente.!",
                                        type: "success",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Continuar!",
                                        closeOnConfirm: false,
                                    },
                                    function(isConfirm) {
                                        if (isConfirm) {
                                            window.location.href = '/';
                                        }
                                    });
                            },
                            error: function(request, error) {
                                sweetAlert("Ha ocurrido un error al intentar archivar la oferta", "error");
                            }
                        });
                    } else {
                        sweetAlert("Cancelado", "La oferta se mantendra Activa !", "error");
                    }
                });
        },
        unstoreOffer: function(offerId) {
            swal({
                    title: "Estás seguro?",
                    text: "Deseas desarchivar esta oferta?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Si",
                    cancelButtonText: "Cancelar",
                    closeOnConfirm: false,
                    closeOnCancel: false
                },
                function(isConfirm) {
                    if (isConfirm) {
                        $.ajax({
                            url: apiUrl + '/offers/' + offerId,
                            type: 'PUT',
                            data: {
                                'status_id': 1
                            },
                            success: function(response) {
                                swal({
                                        title: "Felicidades!",
                                        text: "La oferta se desarchivo correctamente.!",
                                        type: "success",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Continuar!",
                                        closeOnConfirm: false,
                                    },
                                    function(isConfirm) {
                                        if (isConfirm) {
                                            window.location.href = '/';
                                        }
                                    });
                            },
                            error: function(request, error) {
                                sweetAlert("Ha ocurrido un error al intentar desarchivar la oferta", "error");
                            }
                        });
                    } else {
                        sweetAlert("Cancelado", "La oferta se mantendra Inactiva !", "error");
                    }
                });
        },

        deleteOffer: function(offerId) {
            swal({
                    title: "Estás seguro?",
                    text: "Deseas borrar esta oferta?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Si",
                    cancelButtonText: "Cancelar",
                    closeOnConfirm: false,
                    closeOnCancel: false
                },
                function(isConfirm) {
                    if (isConfirm) {
                        $.ajax({
                            url: apiUrl + '/offers/' + offerId,
                            type: 'PUT',
                            data: {
                                'is_deleted': 1
                            },
                            success: function(response) {
                                swal({
                                        title: "Felicidades!",
                                        text: "La oferta se elimino correctamente.!",
                                        type: "success",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Continuar!",
                                        closeOnConfirm: false,
                                    },
                                    function(isConfirm) {
                                        if (isConfirm) {
                                            window.location.href = '/';
                                        }
                                    });
                            },
                            error: function(request, error) {
                                swal("Ha ocurrido un error al intentar borrar la oferta", "error");
                            }
                        });
                    } else {
                        swal("Cancelado", "La oferta se mantendra disponible :)", "error");
                    }
                });
        },

        sync: function(event, tipo) {
            event.preventDefault();
            this[tipo] = event.target.files[0] || event.dataTransfer.files[0];

            var image = new Image();
            var reader = new FileReader();
            var vm = this;
            reader.onload = (event) => {
                vm.imageSrc = event.target.result;
            };

            reader.readAsDataURL(this[tipo]);
        },

        getAllProviders: function() {
            this.$http.get(apiUrl + '/providers').then(response => {
                this.providers = response.data;
            }, response => {
                sweetAlert("Oops...", "Ha ocurrido un error al cargar los proovedores !", "error");
            });
        },

        getOfferType: function() {
            this.$http.get(apiUrl + '/offer-types').then(response => {
                this.type = response.data;
            }, response => {
                sweetAlert("Oops...", "Ha ocurrido al cargar los estados !", "error");
            });
        },
        getOfferServiceType: function() {
            this.$http.get(apiUrl + '/service-types').then(response => {
                this.serviceType = response.data;
            }, response => {
                sweetAlert("Oops...", "Ha ocurrido al cargar los estados !", "error");
            });
        },
    },

    computed: {

        NextDiscount: function() {
            return this.total_sold * this.comission_percent;
        },

        returnValidityInfo: function() {
            if (this.validity == '1') {
                return this.validity = 'Temporal';
            } else {
                return this.validity = 'Indefinida';
            }
        },

        cleanDaysOrFees: function() {
            if (this.selectedType == '1') {
                return this.days = '';
            } else {
                return this.fee = '';
            }
        },

        getDate: function() {
            var today = new Date();
            var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
            return date;
        },
    }
}
</script>
  }
}
</script>



// WEBPACK FOOTER //
// offers-information.vue?5bf213fa